import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  padding: ${rem(24)} ${rem(18)};
  border-radius: ${rem(16)};
  box-shadow: 0 ${rem(6)} ${rem(20)} ${rem(10)} rgba(0, 0, 0, 0.08);
  background: ${({ theme }) => theme.color.white};
  ${({ theme }) => theme.media.fold`
    gap: ${rem(10)};
  `}
`;

export const TopArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TextMiddleArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(16)};
  ${({ theme }) => theme.media.fold`
    gap: ${rem(14)};
  `}
`;

export const Label = styled.div`
  display: flex;
  gap: ${rem(4)};
  align-items: center;
`;
